<template>
  <div>
    <div class="application">
      <div class="line showpc" style="height:60px;border-bottom:solid 1px var(--C3);">
        <div class="line-33">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:left;margin-left:15px;">
            <li style="line-height:60px;">
              <img src="../assets/nozay.jpg" alt="" style="height:50px;margin-top:5px;">
            </li>
          </ul>
        </div>
        <div class="line-34">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:center;">
            <li style="line-height:60px;">
              <img src="../assets/7avelo.png" alt="" style="cursor:pointer;height:50px;margin-top:5px;" @click="navigation('board')">
            </li>
          </ul>
        </div>
        <div class="line-33">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:right;margin-right:15px;">
            <li style="line-height:60px;">
              <login :account="account"></login>
            </li>
          </ul>
        </div>
      </div>
      <div class="line showmobile" style="height:60px;border-bottom:solid 1px var(--C3);">
        <div class="line-50">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:left;margin-left:15px;">
            <li style="line-height:60px;">
              <img src="../assets/nozay.jpg" alt="" style="height:50px;margin-top:5px;">
            </li>
          </ul>
        </div>
        <div class="line-50">
          <ul style="list-style:none;padding:0px;margin:0px;text-align:right;margin-right:15px;">
            <li style="line-height:60px;">
              <login :account="account"></login>
            </li>
          </ul>
        </div>
      </div>
      <div class="line" style="text-align:center;">      
        <h1>Vos locations</h1>
        <h3>Historique de vos contrats de location</h3>
      </div>
      <div class="line-m" style="margin-top:40px;">
        <table class="ftable">
          <tr>
            <th>Numéro de contrat</th>
            <th>Date du contrat</th>
            <th>Numéro de réservation</th>
            <th>Date de début</th>
            <th>Date de fin</th>
          </tr>
          <tr v-for="rental in list" :key="rental.id">
            <td>{{rental.rental_number}}</td>
            <td>{{rental.rental_date|moment('DD/MM/YYYY')}}</td>
            <td>{{rental.resa_number}}</td>
            <td>{{rental.release_date|moment('DD/MM/YYYY')}}</td>
            <td>{{rental.return_date|moment('DD/MM/YYYY')}}</td>
          </tr>
        </table>
      </div>
    </div>
    <loadingform v-if="loading"></loadingform>
  </div>
</template>

<script>
import engine from "../core/DataAPI";
import login from "../core/IconLogin";
import loadingform from "../core/LoadingForm";

export default {
  components:{
    login,loadingform
  },
  data() {
    return {
      loading:false,
      account:{},
      vdate:'',
      list:[]
    }
  },
  created: function(){
    var tmain = this;
    this.$moment.locale('fr');
    tmain.loading=true;
    engine.Account_Info(function(pkg){
      if (pkg.code!=0){
        tmain.loading=false;
        tmain.$router.push('/');
      }else{
        tmain.account = pkg.data[0];
        engine.Rentals_List(function(pkgrentals){
          tmain.loading=false;
          if (pkgrentals.code==0){
            tmain.list = pkgrentals.data;
          }
        });
      }
    });  
  },
  methods: {
    navigation:function(app){
      var tmain = this;
      tmain.$router.push('/'+app);
    }
  }
}
</script>
<style>
</style>
